// PowerPort.js
import React, { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import update from 'react-addons-update'
import { SelectInput } from '../../partials/Inputs/Inputs'

import AppDispatcher from '../../../dispatchers/AppDispatcher'

const PowerPort = (props) => {
  const [powerPort, setPowerPort] = useState(props.device.physical.powerPort)

  const appDispatch = useCallback(() => {
    AppDispatcher.dispatch({
      action: 'change-physical',
      setting: {
        powerPort,
      },
    })
  }, [powerPort])

  useEffect(() => {
    appDispatch()
  }, [appDispatch])

  const childChange = useCallback((event) => {
    handleChange(event.target.name, event.target.value)
  }, [])

  const handleChange = useCallback((field, value, callback) => {
    const newState = update({ powerPort },
      {
        [field]: { $set: value },
      }
    )
    setPowerPort(newState.powerPort)

    // Use setTimeout to ensure state is updated before calling appDispatch
    setTimeout(() => {
      appDispatch()
      if (callback) callback()
    }, 0)
  }, [powerPort, appDispatch])

  const unit = ''

  const select = [
    {
      value: '181',
      name: 'In 1',
    },
    {
      value: '182',
      name: 'In 2',
    },
  ]

  let currentSetting = 'In 1'
  switch (props.device.physical.powerPort ? props.device.physical.powerPort : '181') {
    case '181':
      currentSetting = 'In 1'
      break
    case '182':
      currentSetting = 'In 2'
      break
    default:
      currentSetting = 'In 1'
  }

  return (
    <div>
      <section>
        <h3>
          Current Setting
        </h3>
        <ul>
          <li>
            <span>Power Port</span>
            <span>
              {currentSetting}
              {unit}
            </span>
          </li>
        </ul>
      </section>
      <section>
        <h3>
          New Setting
        </h3>
        <ul>
          <li>
            <span>Power Port</span>
            <span>
              <SelectInput
                value={powerPort}
                childChange={childChange}
                field='powerPort'
                options={select}
              />
              {unit}
            </span>
          </li>
        </ul>
      </section>
    </div>
  )
}

PowerPort.propTypes = {
  device: PropTypes.object.isRequired,
}

export default PowerPort
